import { createFileRoute, redirect } from '@tanstack/react-router';
import { AuthenticatedLayout } from '../components/layout/authenticated-layout';
import { sessionQueryOptions } from '../features/auth/session';

/**
 * Stratul autentificat. Tot ce stă sub el cere sesiune.
 *
 * Ruta e „pathless" (numele începe cu `_`), deci nu adaugă nimic în URL: `/` rămâne `/`.
 * Câștigul e că protecția se scrie **o dată**, iar o pagină nouă o moștenește prin
 * simplul fapt că fișierul ei stă în directorul `_authenticated/`. O verificare copiată
 * în fiecare rută s-ar uita, exact la a douăzecea.
 */
export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async ({ context, location }) => {
    const session = await context.queryClient.ensureQueryData(sessionQueryOptions());

    if (!session) {
      throw redirect({
        to: '/login',
        // Unde voia să ajungă, ca după autentificare să continue de acolo și nu de pe
        // pagina de start.
        search: { redirect: location.href },
      });
    }

    return { session };
  },
  component: AuthenticatedLayout,
});
